import { useState, useEffect } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css"; // Import default styles
import {
  Fullscreen,
  Slideshow,
  Zoom,
  Video,
} from "yet-another-react-lightbox/plugins"; // Import necessary plugins

const ImageLightbox = ({ images, isOpen, startIndex, onClose }) => {
  const [photoIndex, setPhotoIndex] = useState(startIndex);

  // Prevent scrolling when the lightbox is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    isOpen && (
      <Lightbox
        open={isOpen}
        close={onClose}
        slides={images.map((img) => ({ src: img.thumbnail }))}
        index={photoIndex}
        onIndexChange={setPhotoIndex}
        plugins={[Fullscreen, Slideshow, Zoom, Video]}
      />
    )
  );
};

export default ImageLightbox;
